import React from "react";

const NotFound = () => {
  return (
    <div className="middle">
      <h1 className="text-center">404 error</h1>
      <img className="notFound w-50"
        src={
          "https://drudesk.com/sites/default/files/2018-02/404-error-page-not-found.jpg"
        }
        alt=""
      />
    </div>
  );
};

export default NotFound;
